export class EstablishmentProgress{


  step1StructureAndEnterpriseCreated = false;
  step2EmployeeCreation = false;
  step3ScheduleCreation = false;
  step4TimesheetCreation = false;
  step5PayRollExport = false;
  done = false;
  /*
  get isAfterStep1():boolean{
    if (this.step1StructureAndEnterpriseCreated){
      return true;
    }
    return false;
  }

  get isAfterStep2():boolean{
    if (this.step1StructureAndEnterpriseCreated){
      return true;
    }
    return false;
  }
  */

}
